<template>
  <OrConfirmV3
    :title-text="$t('deleteModal.title')"
    :is-open="isOpen"
    :loading="isLoading"
    confirm-type="d"
    :confirm-button-text="$t('common.delete')"
    :cancel-button-text="$t('common.keep')"
    data-test="queue-delete-confirmation"
    @close="$emit('decline')"
    @confirm="$emit('accept')"
  >
    <i18n-t
      keypath="deleteModal.deleteText"
      scope="global"
      tag="span"
    >
      <template #queue>
        <span class="typography-body-2-bold"> {{ queueName }} </span>
      </template>
    </i18n-t>
  </OrConfirmV3>
</template>

<script lang="ts">
import { OrConfirmV3 } from '@onereach/ui-components';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'QueueDeleteModal',
  components: {
    OrConfirmV3,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    queueName: {
      type: String,
      required: true,
    },
  },
  emits: ['decline', 'accept'],
});
</script>
